<template>
<div>
    <div class="login_wrap">
        <dl>
                <dt>핸드폰 번호 변경 완료</dt>
                <dd>
                    연락처 변경이 완료되었습니다.
                </dd>
            </dl>
    </div>
    <div class="btn_box_fixed">
        <a class="default_btn1" @click="$router.go(-3);">
            확인
        </a>
    </div> 

</div>


</template>

<script>
export default {
    name:'PhoneComplete',

    created () {
        this.$store.state.routeBack = -3;
        this.$store.commit('SHOW_ONLOAD');
    },
}
</script>

<style lang="scss" scoped></style>